module.exports = __webpack_public_path__ + "static/media/apple-mobile.df6c75e6.svg";